import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: IndexComponent,
});

function IndexComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900">Yak Network Play</h1>
        <p className="mt-2 text-gray-600">
          Navigate to a landing page URL to start playing.
        </p>
      </div>
    </div>
  );
}
